import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./cardHeader.css";

const CardHeader = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const savedName = localStorage.getItem('name');
    if (savedName) {
      setUserName(savedName);
    }
  }, [])

  // useEffect(() => {
  //   if (token) {
  //     axiosInstance
  //       .get(
  //         `${
  //           process.env.REACT_APP_SERVER
  //             ? process.env.REACT_APP_SERVER
  //             : window.location.origin
  //         }/api/userinfo`,
          
  //       )
  //       .then((response) => {
  //         setUserName(response.data.name);
  //       })
  //       .catch((error) => {
  //         if (error.response?.data?.code === 401) {
  //           // alert("Unauthorized");
  //           // navigate("/hrms");
  //           // localStorage.clear();
  //         }
  //         console.error("Error fetching user info", error);
  //       });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [token]);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
    // axiosInstance.get('/api/logout')
    // .then(() => navigate("/"))
    // .catch((err) => console.error('Logout failed', err));
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className={`navbar ${token ? "navbar-primary" : "navbar-dark"}`}>
      <div className="container">
        <div className="navbar-brand">
          {console.log("Lohith",token)}
          
          <Link to="">
            <strong style={{color:"white"}}>{token ? "Marsforce" : "Not-LoggedIn"}</strong>
          </Link>
        </div>

        <div className="menu-icon" onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          {token ? (
            <>
              <Link to="/dashboard" className="nav-link">
                Myinfo
              </Link>
              <Link to="/userpolicy" className="nav-link">
                Leave Policy
              </Link>
              <Link to="/attendance" className="nav-link">
                Attendance
              </Link>
              <Link to="/myleave" className="nav-link">
                Leave List
              </Link>
              <Link to="/requestleave" className="nav-link">
                Employee Leave Request
              </Link>

             
              <div className="user-info">
                <h6 className="nav-link">
                  <span>Welcome, {userName || "User"}</span>
                </h6>
                <div className="dropdown-menu">
                  <Link to="/" className="nav-link" onClick={handleLogout}>
                    Logout
                  </Link>
                  <Link to="/help" className="nav-link">
                    Help
                  </Link>
                </div>
              </div>
            </>
          ) : (
            <>
              <Link to="/" className="nav-link">
                Login
              </Link>
              <Link to="/register" className="nav-link">
                Signup
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default CardHeader;
